import { IBankAccountType } from 'typescript/interfaces/bankAccountType'

export const bankAccountTypes: IBankAccountType[] = ['Checking', 'Saving']
